'use strict';

// map constants such as bounding box and min/max zoom
// the default view, starting bounding box, min and max zoom, the list of basemap offerings, ...
const REGIONAL_BBOX_S =   37.7217;
const REGIONAL_BBOX_W = -119.5807;
const REGIONAL_BBOX_N =   38.2449;
const REGIONAL_BBOX_E = -118.5686;
const BBOX_REGION = [[REGIONAL_BBOX_S, REGIONAL_BBOX_W], [REGIONAL_BBOX_N, REGIONAL_BBOX_E]];

const MIN_ZOOM =  6;
const MAX_ZOOM = 18;

// the list of basemap options to present in the BasemapBar control
const BASEMAPS = [
    {
        type: 'xyz',
        label: 'map',
        url:'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
        attrib: 'Tiles &copy; Esri &mdash; Source: Esri',
        tooltip: 'Positron Basemap'
    },
    {
        type:'xyz',
        label:'photo',
        url:'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        attrib: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
        tooltip: 'Photo Basemap'
    },
];

// the URL of the WMS
const WMS_URL = "/mapserver/";

// the L.Map
let MAP;

// a stucture of loaded data from the server endpoints, for select options in the filtering UI, the set of Diversion points system-wide, and so on
// this is populated by the startup promises, but after that should be treated as read-only
const DATASETS = {};

// Diversion points on the map, come in a variety of styles; see redrawMapMarkers()
// default, a Diversion marker
// search result, a Diversion marker which is part of a Water Right that is in the search results
// analysis result, a Diversion marker which is in the upstream/downstream analysis
// analysis query, the Diversion marker which was the bassis of the upstream/downstream analysis
const DIVERSION_POINT_DEFAULT_STYLE = { radius: 9, fillColor: "black", fillOpacity: 1, color: "#808080", opacity: 1, weight: 1 };
const DIVERSION_POINT_MATCHSEARCH_STYLE = { radius: 9, fillColor: "black", fillOpacfillOpacity: 1, color: "#808080", opacity: 1, weight: 1 };
const DIVERSION_POINT_ANALYSISQUERY_STYLE = { radius: 13, fillColor: "white", fillOpacity: 1, color: "#808080", opacity: 1, weight: 4 };
const DIVERSION_POINT_ANALYSIS_UPSTREAM_STYLE = { radius: 9, fillColor: "#c6e8f1", fillOpacity: 1, color: "#808080", opacity: 1, weight: 2 };
const DIVERSION_POINT_ANALYSIS_DOWNSTREAM_STYLE = { radius: 9, fillColor: "#f7d1d7", fillOpacity: 1, color: "#808080", opacity: 1, weight: 2 };

// the latest set of waterright search results, and of Analyze results
let WATERRIGHT_SEARCH_RESULTS;
let DIVERSION_ANALYSIS_RESULTS;

// the set of WMS map layers for the map
// some of these are always-on via initMap() e.g. streams and selected-area highlights
// the filter_XXX some are contrived to match the name of the filter section's toggle, and will be toggled by selectBoundaryLayer()
const MAPLAYERS = {};

MAPLAYERS.streams = L.tileLayer.wms(WMS_URL, { layers:'streams', tileSize: 1024, format:'image/png', transparent:true, zIndex: 10 });

MAPLAYERS.filter_divhuc12 = L.tileLayer.wms(WMS_URL, { layers:'boundaries_huc12', tileSize: 1024, format:'image/png', transparent:true, opacity: 0.6, zIndex: 70 });
MAPLAYERS.filter_divhuc8 = L.tileLayer.wms(WMS_URL, { layers:'boundaries_huc8', tileSize: 1024, format:'image/png', transparent:true, opacity: 0.6, zIndex: 70 });
MAPLAYERS.filter_divcounty = L.tileLayer.wms(WMS_URL, { layers:'boundaries_county', tileSize: 1024, format:'image/png', transparent:true, opacity: 0.6, zIndex: 70 });
// MAPLAYERS.filter_divwatershed = L.tileLayer.wms(WMS_URL, { layers:'boundaries_watershed', tileSize: 1024, format:'image/png', transparent:true, opacity: 0.6, zIndex: 70 });

MAPLAYERS.selected_divhuc12 = L.tileLayer.wms(WMS_URL, { layers:'selected_huc12', tileSize: 1024, format:'image/png', ID: '0', transparent:true, zIndex: 100 });
MAPLAYERS.selected_divhuc8 = L.tileLayer.wms(WMS_URL, { layers:'selected_huc8', tileSize: 1024, format:'image/png', ID: '0', transparent:true, zIndex: 100 });
MAPLAYERS.selected_divcounty = L.tileLayer.wms(WMS_URL, { layers:'selected_county', tileSize: 1024, format:'image/png', ID: '0', transparent:true, zIndex: 100 });
//MAPLAYERS.selected_divwatershed = L.tileLayer.wms(WMS_URL, { layers:'selected_watershed', tileSize: 1024, format:'image/png', ID: '0', transparent:true, zIndex: 100 });


/* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */


$(document).ready(function () {
    // startup is blocked while we pre-load these AJAX data endpoints into the DATASETS read-only globals
    // usng lazy loading of AJAX means a lot of little waits during usage as one types, which is more annoying than one big wait at startup
    // having options' IDs known at startup also allows us to save/load URL params, which is always important
    // so it pays to just pre-load everything and know that we have it ready without race conditions later
    const waitforparsing = [
        new Promise(function(resolve) { $.get('/api/diversion/source/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/watersheds/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/counties/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/watersheds/huc8/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/watersheds/huc12/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/waterright/type/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/waterright/status/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/waterright/owner/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/waterright/beneficialuses/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/waterright/applicationid/', (data) => { resolve(data); }, 'json'); }),
        new Promise(function(resolve) { $.get('/api/diversions/', (data) => { resolve(data); }, 'json'); }),

    ];

    Promise.all(waitforparsing).then(function (datasets) {
        // save the datasets into these read-only globals, where we can use them later to set up UI
        DATASETS.options_source = datasets[0].results;
        DATASETS.options_watershed = datasets[1].results;
        DATASETS.options_county = datasets[2].results;
        DATASETS.options_huc8 = datasets[3].results;
        DATASETS.options_huc12 = datasets[4].results;
        DATASETS.options_type = datasets[5].results;
        DATASETS.options_status = datasets[6].results;
        DATASETS.options_owner = datasets[7].results;
        DATASETS.options_beneficial = datasets[8].results;
        DATASETS.options_applicationid = datasets[9].results;
        DATASETS.diversionmarkers = datasets[10];

        // now we can get started!
        initAccordion();
        initMap();
        initSidebarTogglers();
        initSearchForm();
        initSearchPills();
        initSearchResults();
        initAnalysisResultsPanel();

        const hasparams = initLoadInitialState();
        initUrlUpdater();
        initSearchTriggers();

        if (hasparams) {
            performSearch();
        }
        else {
            redrawMapMarkers();
        }
    });
});


function initUrlUpdater () {
    // fetch params then do some massaging to join values for strings
    // see also initLoadInitialState() which parses these URL params on startup
    function updateUrlParams () {
        const params = compileSearchParams();

        // add params not used for searching: map XYZ
        params.z = MAP.getZoom();
        params.x = MAP.getCenter().lng.toFixed(5);
        params.y = MAP.getCenter().lat.toFixed(5);

        // if present, join these params into strings
        // can't use comma because they chose to use random strings in their text domain values, which include commas (smh)
        [
            'facevalue', 'acceptdate',
            'divsource', 'divwatershed', 'divcounty', 'divhuc8', 'divhuc12',
            'wrtype', 'wrstatus', 'owner', 'beneficial', 'applicationid'
        ].forEach(function (fieldname) {
            if (! params[fieldname]) return;
            params[fieldname] = params[fieldname].join('|');
        });

        // join it and save it
        const paramstring = $.param(params);
        const url = `${document.location.protocol}//${document.location.host}${document.location.pathname}?${paramstring}`;
        history.replaceState(null, null, url);
    }
    setInterval(updateUrlParams, 1 * 1000);
}


function initLoadInitialState() {
    // see also initUrlUpdater() and compileSearchParams() which composed the query string
    const $form = $('#SearchForm');
    const urlparams = new URLSearchParams(document.location.search.substring(1));
    let hasanyparams = 0;

    // map XYZ
    if (urlparams.get('x') && urlparams.get('y') && urlparams.get('z')) {
        const zoom = parseInt(urlparams.get('z'));
        const latlng = [ parseFloat(urlparams.get('y')), parseFloat(urlparams.get('x')) ];
        MAP.setView(latlng, zoom);
    }

    // single values
    if (urlparams.get('riparian')) {
        const $input = $form.find('select[name="riparian"]');
        $input.val(urlparams.get('riparian'));
        hasanyparams += 1;
    }
    if (urlparams.get('pre1914')) {
        const $input = $form.find('select[name="pre1914"]');
        $input.val(urlparams.get('pre1914'));
        hasanyparams += 1;
    }

    // value pairs as a 2-tuple
    if (urlparams.get('facevalue') && urlparams.get('facevalue').match(/\d+\|\d+/)) {
        const minmax = urlparams.get('facevalue').split('|');
        $form.find('input[name="facevalue_min"]').val(parseInt(minmax[0]));
        $form.find('input[name="facevalue_max"]').val(parseInt(minmax[1]));
        hasanyparams += 1;
    }
    if (urlparams.get('acceptdate') && urlparams.get('acceptdate').match(/\d+\|\d+/)) {
        const minmax = urlparams.get('acceptdate').split('|');
        $form.find('input[name="acceptdate_min"]').val(parseInt(minmax[0]));
        $form.find('input[name="acceptdate_max"]').val(parseInt(minmax[1]));
        hasanyparams += 1;
    }

    // lists of multiselect values
    if (urlparams.get('applicationid')) {
        const values = urlparams.get('applicationid').split('|');
        $form.find('select[name="applicationid"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('divsource')) {
        const values = urlparams.get('divsource').split('|');
        $form.find('select[name="divsource"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('divwatershed')) {
        const values = urlparams.get('divwatershed').split('|');
        $form.find('select[name="divwatershed"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('divcounty')) {
        const values = urlparams.get('divcounty').split('|');
        $form.find('select[name="divcounty"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('divhuc8')) {
        const values = urlparams.get('divhuc8').split('|');
        $form.find('select[name="divhuc8"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('divhuc12')) {
        const values = urlparams.get('divhuc12').split('|');
        $form.find('select[name="divhuc12"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('wrtype')) {
        const values = urlparams.get('wrtype').split('|');
        $form.find('select[name="wrtype"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('wrstatus')) {
        const values = urlparams.get('wrstatus').split('|');
        $form.find('select[name="wrstatus"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('owner')) {
        const values = urlparams.get('owner').split('|');
        $form.find('select[name="owner"]').val(values).change();
        hasanyparams += 1;
    }
    if (urlparams.get('beneficial')) {
        const values = urlparams.get('beneficial').split('|');
        $form.find('select[name="beneficial"]').val(values).change();
        hasanyparams += 1;
    }

    // run an Analyze on startup?
    if (urlparams.get('analyze')) {
        const diversionid = urlparams.get('analyze');
        runDiversionAnalysis(diversionid);
    }

    // return whether we got any URL params which should trigger a search at startup
    return hasanyparams;
}


function initSidebarTogglers() {
    const $sidebar = $('#Sidebar');
    const $opener = $('#SidebarOpener');
    const $closer = $('#SidebarCloser');

    $opener.click(function () {
        $sidebar.removeClass('d-none');
        $closer.removeClass('d-none');
        $opener.addClass('d-none');
    });

    $closer.click(function () {
        $sidebar.addClass('d-none');
        $closer.addClass('d-none');
        $opener.removeClass('d-none');
    });

    $opener.click();
}


function initAccordion() {
    // Bootstrap accordions work nicely, but we always want something special
    // e.g. changing this icon inside the toggler, so it LOOKS like an accordion
    const $divs = $('#Sidebar-Accordion > div.collapse');
    const $triggers = $('#Sidebar-Accordion > a');

    function updateButtonIcon ($button) {
        const $i = $button.children('i');
        const ishidden = $button.hasClass('collapsed');

        if (ishidden) {
            $i.addClass('glyphicons-chevron-right').removeClass('glyphicons-chevron-down');
        }
        else {
            $i.removeClass('glyphicons-chevron-right').addClass('glyphicons-chevron-down');
        }
    }

    $divs.on('shown.bs.collapse', function () {
        const $button = $(this).prev('a[data-toggle="collapse"]');
        updateButtonIcon($button);
    });
    $divs.on('hidden.bs.collapse', function () {
        const $button = $(this).prev('a[data-toggle="collapse"]');
        updateButtonIcon($button);
    });

    $triggers.click();  // by default, expand both sections
}


function initSearchForm () {
    // the triggers to performSearch() when these change, is initSearchTriggers() so it may be done after we pre-populate initLoadInitialState()
    const $form = $('#SearchForm');
    const $select2ajaxpickers = $('select[multiple]');
    const $textfields = $form.find('input[type="text"]');
    const $numberfields = $form.find('input[type="number"]');

    // set up the Select2 items, whose DATASETS globals were populated from AJAX sources during the startup promises
    // they have variations such as placeholder text and AJAX URL, but instead of repeating Select2 code, we put those into data-XXX attributes to read them here
    // the data endpoints are already set up to output in a Select2-ready format
    function loadPickerAndActivate ($picker, optionlist) {
        // populate options
        optionlist.forEach(function (option) {
            $('<option></option>').prop('value', option.id).text(option.text).appendTo($picker);
        });

        // set up Select2; fetch some options from the HTML e.g. placeholder text
        $picker.select2({
            placeholder: "",  // do not use placeholder, we have a CSS hack to not show content here and it looks weird for placeholder to "vanish"
            minimumInputLength: 0,  // show all options if they focus, before they even start typing
            width: '100%',
        });
    }

    loadPickerAndActivate($select2ajaxpickers.filter('[name="divsource"]'), DATASETS.options_source);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="divwatershed"]'), DATASETS.options_watershed);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="divcounty"]'), DATASETS.options_county);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="divhuc8"]'), DATASETS.options_huc8);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="divhuc12"]'), DATASETS.options_huc12);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="wrtype"]'), DATASETS.options_type);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="wrstatus"]'), DATASETS.options_status);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="owner"]'), DATASETS.options_owner);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="beneficial"]'), DATASETS.options_beneficial);
    loadPickerAndActivate($select2ajaxpickers.filter('[name="applicationid"]'), DATASETS.options_applicationid);

    // the basic expand/collapse behavior driven by the switch checkboxes
    // later decided to have one-at-a-time behavior, that only one of each section (Geography, Attribute) can be expanded at a time
    // but also a twist: if a section becomes open, focus the first input/select to save them a click
    const $radios = $form.find('input[type="checkbox"][aria-controls][aria-expanded]');
    $radios.change(function () {
        const $this = $(this);
        const checked = $this.is(':checked');

        const divid = $this.attr('aria-controls');
        const $div = $form.find(`div#${divid}`);

        const $input = $div.find('input[type="number"],input[type="text"],select').first();
        const $section = $div.closest('.SearchForm-Section');
        const $otherchecks = $section.find('input[type="checkbox"][aria-controls][aria-expanded]').not($this).filter(':checked');

        if (checked) {
            $div.show();
            $this.prop('aria-expanded', 'true');

            $input.focus();
            // if ($input.is('select.select2-hidden-accessible')) $input.select2('open');  // acts buggy with the uncheck behavior below, because things moves

            $otherchecks.prop('checked', false).change();
        }
        else {
            $div.hide();
            $this.prop('aria-expanded', 'false');
        }
    });
    $radios.change();  // trigger now to hide all, but AFTER Select2 has initialized, or else select2 UI bugs

    // custom UI behavior here: expanding/collapsing the Geography filters, is also how we toggle the boundary layers
    // find the button's toggled DIV, and that DIV's input's name
    const $georadios = $form.find('div.SearchForm-Section-Geography').find('input[type="checkbox"][aria-controls][aria-expanded]');
    $georadios.change(function () {
        const $checkedone = $georadios.filter(':checked');

        let boundaryname = '';  // nothing checked = this stays blank
        if ($checkedone.length) {
            const divid = $checkedone.attr('aria-controls');
            const $div = $form.find(`div#${divid}`);
            const $input = $div.find('input[type="number"],input[type="text"],select').first();
            boundaryname = $input.attr('name');
        }
        selectBoundaryLayer(boundaryname);
    });

    // minor usability enhancements that add up: upons focusing a text/number box here, save them a few clicks to select and delete text, by selecting it for them
    $textfields.on('focus', function () {
        $(this).select();
    });
    $numberfields.on('focus', function () {
        $(this).select();
    });

    // add to the radioboxes, these readouts for how many options are selected within that section
    const $checkboxlabels = $form.find('.SearchForm-Section > label');
    $checkboxlabels.each(function () {
        const $checkboxlabel = $(this);

        $('<span class="SearchForm-Section-Count"></span>').text('0').addClass('d-none').insertAfter($checkboxlabel);
    });
}


function initSearchResults () {
    // Bootstrap accordions work nicely, but we always want something special such as changing the icons inside the togglers
    // this is a delegated event handler, for content which would be generated by performSearch_ResultListing()
    const $readout = $('#SearchResults');

    function updateButtonIcon ($button) {
        const $i = $button.children('i');
        const ishidden = $button.hasClass('collapsed');

        if (ishidden) {
            $i.removeClass('glyphicons-remove').addClass('glyphicons-chevron-right');
        }
        else {
            $i.addClass('glyphicons-remove').removeClass('glyphicons-chevron-right');
        }
    }

    $readout.on('shown.bs.collapse', 'div.SearchResults-Result-Details', function () {
        const $button = $(this).prev('a[data-toggle="collapse"]');
        updateButtonIcon($button);
    });
    $readout.on('hidden.bs.collapse', 'div.SearchResults-Result-Details', function () {
        const $button = $(this).prev('a[data-toggle="collapse"]');
        updateButtonIcon($button);
    });

    // delegated event handler in search results listing
    // click a Diversion's mag-glass = zoom to it
    $readout.on('click', '.SearchResults-Result-Diversion i.glyphicons-search', function () {
        const diversion = $(this).closest('div.SearchResults-Result-Diversion').data('diversion');
        const marker = getDiversionMarkerById(diversion.id);

        if (marker) {
            MAP.setView(marker.getLatLng(), MAX_ZOOM);
            marker.bringToFront();
            marker.fire('click');
        }
        else {
            console.error(['No diversion marker found to zoom.', diversion]);
        }
    });

    // delegated event handler in search results listing AND in the Diversion info popup
    // click a Diversion's Analyze Button = go to the POD analysis view
    // see showDiversionInfoPopup() and performSearch_ResultListing()
    $('#SearchResults').on('click', '.SearchResults-Result-DiversionAnalyzeButton', function () {
        const diversion = $(this).closest('div.SearchResults-Result-Diversion').data('diversion');
        runDiversionAnalysis(diversion.id);
    });

    $('#Map').on('click', '.Diversion-Popup .Diversion-Popup-DiversionAnalyzeButton', function () {
        const diversion = $(this).closest('div.Diversion-Popup').data('diversion');
        runDiversionAnalysis(diversion.id);
    });
}


function initSearchPills () {
    // deletegated event handler on Search Pills to clear each filter
    // see performSearch_SearchPills() which creates these, including their clickcallback
    const $pillsarea = $('#Search-Pills');

    $pillsarea.on('click', 'span i', function () {
        const clearfunction = $(this).closest('span').data('clickcallback');
        clearfunction();
    });
}


function initSearchTriggers () {
    const $form = $('#SearchForm');
    const $selects = $form.find('select');
    const $textfields = $form.find('input[type="text"]');
    const $numberfields = $form.find('input[type="number"]');

    $selects.change(function () {
        performSearch();
    });
    $textfields.change(function () {
        performSearch();
    });
    $numberfields.change(function () {
        // if value is blank, fill in the min/max so the field isn't really blank
        const $this = $(this);
        const value = $this.val();
        const name = $this.prop('name');

        if (! value && name.substr(-4) == '_min') {
            $this.val($this.prop('min'));
        }
        else if (! value && name.substr(-4) == '_max') {
            $this.val($this.prop('max'));
        }

        performSearch();
    });
}


function initAnalysisResultsPanel () {
    const $analysis = $('#DiversionAnalysis');

    // close button = clear Analysis and close the panel
    const $closebutton = $analysis.find('div.titlebar > a');
    $closebutton.click(function () {
        clearAnalysis();
    });

    // change the sort selector = re-populate the analysis Diversions listing
    const $sorter = $('#DiversionAnalysis-SortLegend select');
    $sorter.change(function () {
        runDiversionAnalysis_updateListing();
    });

    // delegated event handler in analysis results listing
    // click a Diversion's mag-glass = zoom to it
    $analysis.on('click', '.AnalysisDiversion a.AnalysisDiversion-DiversionIdButton', function () {
        const diversion = $(this).closest('div.AnalysisDiversion').data('diversion');
        const marker = getDiversionMarkerById(diversion.id);

        if (marker) {
            MAP.panTo(marker.getLatLng());
            marker.bringToFront();
            marker.fire('click');
        }
        else {
            console.error(['No diversion marker found to zoom.', diversion]);
        }
    });
}


function initMap() {
    MAP = new L.Map('Map', {
        minZoom: MIN_ZOOM,
        maxZoom: MAX_ZOOM,
        zoomControl: false, // see custom one below
        attributionControl: false, // see custom one below
        // maxBounds: [[REGIONAL_BBOX_S, REGIONAL_BBOX_W], [REGIONAL_BBOX_N, REGIONAL_BBOX_W]],
        editable: true,  // used for Leaflet.Editable and thus MAP.editingparkshape
    });
    MAP.fitBounds(BBOX_REGION);

    new L.Control.BasemapBar({
        layers:BASEMAPS,
    }).addTo(MAP).selectLayer(BASEMAPS[0].label);

    new L.Control.ZoomBar({
        position: 'topright',
        homeBounds: BBOX_REGION,
    }).addTo(MAP);

    L.control.attribution({
        position: 'bottomleft',
    })
    .addTo(MAP);

    new L.controlCredits({
        image: '/static/images/greeninfo.png',
        link: 'https://www.greeninfo.org/',
        text: 'Interactive mapping<br/>by GreenInfo Network',
        position: 'bottomleft',
    }).addTo(MAP);

    L.control.scale({
        position: 'bottomright',
        updateWhenIdle: true
    }).addTo(MAP);

    // some of the MAPLAYERS are always on, e.g. streams; add them now
    // others are toggled so only one shows at a time, e.g. boundaries which are tied to filtering UI, see selectBoundaryDisplay()
    MAPLAYERS.streams.addTo(MAP);  // always on
    MAPLAYERS.selected_divhuc12.addTo(MAP);  // see performSearch_MapBoundaries() which changes filters here
    MAPLAYERS.selected_divhuc8.addTo(MAP);  // see performSearch_MapBoundaries() which changes filters here
    MAPLAYERS.selected_divcounty.addTo(MAP);  // see performSearch_MapBoundaries() which changes filters here

    // all Diversions points; bounce it off L.geoJson for the parsing and feature-to-layer conversion, and load into a marker clusterer
    // we have MAP.allpodmarkers for all markers in the universe, and MAP.diversionmarkers for the ones currently on the map
    // see redrawMapMarkers() which shifts markers and changes their styles these based on various criteria
    MAP.allpodmarkers = L.geoJson(DATASETS.diversionmarkers, {
        pointToLayer: function (feature, latlng) {
            const tooltip = `POD ID: ${feature.properties.podid}<br/>Water Right ${feature.properties.waterright_applicationid}<br/>Diversion Type(s): ${feature.properties.types}<br/>Status: ${feature.properties.status}`;

            const marker = L.circleMarker(latlng, DIVERSION_POINT_DEFAULT_STYLE).bindTooltip(tooltip);

            marker.on('click', function (event) {  // performance tip: bindPopup() on many features is slow, a click handler to a callback is fast
                L.DomEvent.stopPropagation(event);
                showDiversionInfoPopup(this);
            });

            return marker;
        },
    }).getLayers();  // a list of L.Marker instances with events and everything

    MAP.diversionmarkers = L.markerClusterGroup({
        showCoverageOnHover: false,
        zoomToBoundsOnClick: false,  // instead we have a click handler to spiderfy regardless of zoom level
        spiderfyOnMaxZoom: true,
        maxClusterRadius: 1,  // 0 would be precise latlng match, but even at 1 overlapping markers are visually impossible to distinguish esp at varying sizes, so don't do that
    	iconCreateFunction: function (cluster) {
            // the cluster icons should be colored with DIVERSION_POINT_XXX_STYLE depending on the markers inside,
            // e.g. the upstream color if all markers are upstream, or the in-search-results color if all icons are in the search results
            // see redrawMapMarkers() which reassigns styles to the markers based on the situation, as well as the "flags" which we examine here
            // to define 2^X potential combinations of CSS class
    		const howmany = cluster.getChildCount();

            let iconclasses = ['marker-cluster'];
            const flags = {
                istheanalyzeddiversion: false,
                isinanalysis: false,
                isinsearchresults: false,
            };
            cluster.getAllChildMarkers().forEach(function (layer) {
                if (! layer.flags) return;
                if (layer.flags.istheanalyzeddiversion) flags.istheanalyzeddiversion = true;
                if (layer.flags.isinanalysis) flags.isinanalysis = true;
                if (layer.flags.isinsearchresults) flags.isinsearchresults = true;
                if (layer.flags.upstream) flags.upstream = true;
                if (layer.flags.downstream) flags.downstream = true;
            });
            if (flags.istheanalyzeddiversion) iconclasses.push('marker-cluster-istheanalyzeddiversion');
            if (flags.isinanalysis) iconclasses.push('marker-cluster-isinanalysis');
            if (flags.isinsearchresults) iconclasses.push('marker-cluster-isinsearchresults');
            if (flags.upstream) iconclasses.push('marker-cluster-upstream');
            if (flags.downstream) iconclasses.push('marker-cluster-downstream');

            const html = `<div><span>${howmany}</span></div>`;

            const icon = new L.DivIcon({
                html: html,
                className: iconclasses.join(' '),
                iconSize: new L.Point(40, 40),
            });

    		return icon;
    	},
    })
    .addTo(MAP);

    MAP.diversionmarkers.on('clusterclick', function (event) {  // event.layer is the cluster
    	event.layer.spiderfy();
    });

    // click handler on the map, and a very idiosyncratic one
    // figure out what boundary layer is selected and query it, getting back the polygon's ID
    // then, trigger that area in the select2 as if it had been selected via the select2 UI
    // or
    // if no filtering layer is turned on, query streams instead
    MAP.on('singleclick', function (event) {
        let querylayername = Object.keys(MAPLAYERS).filter(layername => layername.indexOf('filter_') == 0).filter(layername => MAP.hasLayer(MAPLAYERS[layername]))[0];
        if (! querylayername) querylayername = 'streams';
        const querylayer = MAPLAYERS[querylayername];

        const point = MAP.latLngToContainerPoint(event.latlng, MAP.getZoom());
        const mapsize = MAP.getSize();
        const bbox = MAP.getBounds().toBBoxString();

        const params = {
            request: 'GetFeatureInfo',
            service: 'WMS',
            srs: 'EPSG:4326',
            styles: querylayer.wmsParams.styles,
            transparent: querylayer.wmsParams.transparent,
            version: querylayer.wmsParams.version,      
            format: querylayer.wmsParams.format,
            bbox: bbox,
            height: mapsize.y,
            width: mapsize.x,
            layers: querylayer.wmsParams.layers,
            query_layers: querylayer.wmsParams.layers,
            info_format: 'application/vnd.ogc.gml',
        };
        params[params.version === '1.3.0' ? 'i' : 'x'] = point.x;
        params[params.version === '1.3.0' ? 'j' : 'y'] = point.y;

        // send off the WMS query and get back a XML document with area name and ID
        // then select/de-select that area in the picker which corresponds to the layer
        // or
        // unless it's the streams layer, which makes a popup instead
        $.get(WMS_URL, params, function (reply) {
            if (querylayername == 'streams') return showStreamInfoPopup(event.latlng, $(reply));

            const areaid = $(reply).find('id').text();
            const $form = $('#SearchForm');

            let $picker;
            switch (querylayername) {
                case 'filter_divhuc12':
                    $picker = $form.find(`select[name="divhuc12"]`);
                    break;
                case 'filter_divhuc8':
                    $picker = $form.find(`select[name="divhuc8"]`);
                    break;
                case 'filter_divcounty':
                    $picker = $form.find(`select[name="divcounty"]`);
                    break;    
                default:
                    throw new Error("singleclick got unexpected area type");
            }

            let values = $picker.val().slice();
            if (values.indexOf(areaid) == -1) values.push(areaid);
            else values = values.filter(i => i != areaid);
            $picker.val(values).change();
        }, 'xml');
    });
}


// a function to show the #OneMomentPlease modal
function showOneMomentPlease (showit) {
     const $modal = $('#OneMomentPlease');

    if (showit) {
        $modal.modal('show');
    }
    else {
        $modal.modal('hide');
    }
}


function compileSearchParams () {
    const $form = $('#SearchForm');
    const params = {};

    // when coding these values, on THIS case we need to be extra careful about including values with no data
    // since on our use case we don't want to submit a search with filters that effectively Just Show Everything

    // single values
    const singleselects = [ 'riparian', 'pre1914' ];
    singleselects.forEach(function (fieldname) {
        const value = $form.find(`select[name="${fieldname}"]`).val();
        if (value) params[fieldname] = value;
    });

    // multiselects, may be array of IDs or may be null
    const multiselects = [ 'divsource', 'divwatershed', 'divcounty', 'divhuc8', 'divhuc12', 'wrtype', 'wrstatus', 'owner', 'beneficial', 'applicationid' ];
    multiselects.forEach(function (fieldname) {
        const value = $form.find(`select[name="${fieldname}"]`).val();
        if (value && value.length) params[fieldname] = value;
    });

    // value pairs, as a 2-tuple
    const numberpairs = ['facevalue', 'acceptdate'];
    numberpairs.forEach(function (fieldname) {
        const min = $form.find(`input[name="${fieldname}_min"]`).prop('min');
        const max = $form.find(`input[name="${fieldname}_max"]`).prop('max');
        const value1 = $form.find(`input[name="${fieldname}_min"]`).val();
        const value2 = $form.find(`input[name="${fieldname}_max"]`).val();

        if (! value1 || ! value2) return;  // missing either value; even a 0 is "0" so would be true
        if (value1 == min && value2 == max) return;  // same as min/max = not really filtering
        params[fieldname] = [value1, value2];
    });

    // if we have an Analysis in place, include that too
    if (DIVERSION_ANALYSIS_RESULTS) {
        params.analyze = DIVERSION_ANALYSIS_RESULTS.query.id;
    }

    return params;
}


function performSearch () {
    const url = '/prioritytool/search/';
    const params = compileSearchParams();

    // only submit a search if we are really searching; unlike other use cases, we do not want to submit a search with no filtes and get back Everything
    // our handling is the same in every case: a no-search is effectively short-circuited as a search with 0 results
    function handleSearchResults () {
        performSearch_ResultCountReadout();
        redrawMapMarkers();
        performSearch_ResultListing();
    }

    showOneMomentPlease(true);

    MAP.closePopup();

    performSearch_SearchPills();
    performSearch_SectionCounts();
    performSearch_MapBoundaries();

    const isrealsearch = Object.keys(params).length > 0;

    if (isrealsearch) {
        $.get(url, params, function (results) {
            showOneMomentPlease(false);
            WATERRIGHT_SEARCH_RESULTS = results;
            handleSearchResults();
        }, 'json')
        .fail(function() {
            showOneMomentPlease(false);
            alert("There was a problem searching. Please report this.");
        });
    }
    else {
        showOneMomentPlease(false);
        WATERRIGHT_SEARCH_RESULTS = undefined;
        handleSearchResults();
    }
}


function performSearch_MapBoundaries () {
    // given the boundary IDs selected for filtering, highlight those on the map
    const params = compileSearchParams();

    MAPLAYERS.selected_divcounty.setParams({
        'ID': params.divcounty ? params.divcounty.join(',') : '0',
    });
    MAPLAYERS.selected_divhuc8.setParams({
        'ID': params.divhuc8 ? params.divhuc8.join(',') : '0',
    });
    MAPLAYERS.selected_divhuc12.setParams({
        'ID': params.divhuc12 ? params.divhuc12.join(',') : '0',
    });
}


function performSearch_SearchPills () {
    // because we need to refer to the select elements in order to get string labels, we don't use cmopielSearchParams() here
    // but instead peek at the selectors themselves
    const $pillsarea = $('#Search-Pills');
    const $form = $('#SearchForm');

    function addPill (label, callback) {
        // see initSearchPills() for the delegated event handler to fire each pill's custom callback
        const $i = $('<i class="glyphicons glyphicons-remove"></i>');
        const $pill = $('<span></span>').text(label).data('clickcallback', callback).append($i);
        $pill.prop('title', "Click X to clear this filter");
        $pill.appendTo($pillsarea);
    }

    $pillsarea.empty();

    // single select values
    // clear = set the select field to '' value
    ['riparian', 'pre1914']
    .forEach(function (filtername) {
        const $picker = $form.find(`select[name="${filtername}"]`);
        if (! $picker.val()) return;  // default/blank selected, so not really filtering

        const label = $picker.find('option:selected').text();
        const callback = function () { $picker.val('').change(); };
        addPill(label, callback);
    });

    // value pairs, 2 separate pills for the 2 separate fields
    // clear = set the field corresponding to the button, to the field's min/max which is also its default
    ['facevalue', 'acceptdate']
    .forEach(function (filtername) {
        const $inputmin = $form.find(`input[name="${filtername}_min"]`);
        const $inputmax = $form.find(`input[name="${filtername}_max"]`);

        let labelmin, labelmax;
        switch (filtername) {
            case 'facevalue':
                labelmin = `Face Value $${$inputmin.val()} or more`;
                labelmax = `Face Value $${$inputmax.val()} or less`;
                break;
            case 'acceptdate':
                labelmin = `Accept date ${$inputmin.val()} or later`;
                labelmax = `Accept date ${$inputmax.val()} or earlier`;
                break;
            default:
                labelmin = $inputmin.val();
                labelmax = $inputmax.val();
                break;
        }

        if ($inputmin.val() != $inputmin.prop('min')) {
            const callback = function () { $inputmin.val( $inputmin.prop('min') ).change(); };
            addPill(labelmin, callback);
        }
        if ($inputmax.val() != $inputmax.prop('max')) {
            const callback = function () { $inputmax.val( $inputmax.prop('max') ).change(); };
            addPill(labelmax, callback);
        }
    });

    // multiselects, may be array of IDs or may be null
    // clear = de-select this one value from the multiselect
    ['divsource', 'divwatershed', 'divcounty', 'divhuc8', 'divhuc12', 'wrtype', 'wrstatus', 'owner', 'beneficial', 'applicationid']
    .forEach(function (filtername) {
        const $picker = $form.find(`select[multiple][name="${filtername}"]`);
        const values = $picker.val();
        if (! values || ! values.length) return;  // default/blank selected, so not really filtering

        values.forEach(function (value) {
            let label = $picker.find(`option[value="${value}"]`).text();
            switch (filtername) {
                case 'divcounty':
                    label = `${label} County`;
                    break;
            }

            const callback = function () {
                const values = $picker.val().slice().filter(optval => optval != value);
                $picker.val(values).change();
            };

            addPill(label, callback);
        });
    });
}


function performSearch_SectionCounts () {
    // update those little number readouts of how many options are selected in each section's input
    // weirdness: most are select2 multiselects, some are text/number inputs
    const $form = $('#SearchForm');
    const $checkboxlabels = $form.find('.SearchForm-Section > label');

    $checkboxlabels.each(function () {
        const $this = $(this);
        const $countreadout = $this.next('.SearchForm-Section-Count');
        const $realcheckbox = $this.find('input[type="checkbox"][aria-controls]');
        const divid = $realcheckbox.attr('aria-controls');
        const $div = $form.find(`div#${divid}`);

        const $input = $div.find('input[type="number"],input[type="text"],select');

        let count = 0;
        if ($input.length == 2 && $input.first().prop('tagName') == 'INPUT' && $input.first().prop('type') == 'number') {
            // a pair of number inputs, being a min and a max; report how many have a value other than their own min/max which is also their default
            const $inputmin = $input.first();
            const $inputmax = $input.last();
            if ($inputmin.val() != $inputmin.prop('min')) count += 1;
            if ($inputmax.val() != $inputmax.prop('max')) count += 1;
        }
        else if ($input.first().prop('tagName') == 'SELECT' && ! $input.prop('multiple')) {
            // a single select, a regular kind not a select2 multiselect; default is first option, so selectedIndex>0 is non-default choice
            const i = $input[0].selectedIndex;
            if (i > 0) count += 1;
        }
        else if ($input.first().prop('tagName') == 'SELECT' && $input.prop('multiple')) {
            // select2 multiselect, number of val() options in the list
            const i = $input.val() ? $input.val().length : 0;
            count += i;
        }

        // update the number in the readout
        $countreadout.text(count);
        if (count) {
            $countreadout.removeClass('d-none');
        }
        else {
            $countreadout.addClass('d-none');
        }
    });
}


function performSearch_ResultListing () {
    const $readout = $('#SearchResults');
    $readout.empty();

    if (! WATERRIGHT_SEARCH_RESULTS) return;

    WATERRIGHT_SEARCH_RESULTS.forEach(function (waterright) {
        // create DIVs and a .collapse effect and a data-parent so they can expand one WR at a time
        // see also initSearchResults() for delegated event handlers relevant here e.g. to change i icon
        const divid = `SearchResults-Result-${waterright.id}`;

        const $toggler = $(`<a class="SearchResults-Result-Title collapsed" data-toggle="collapse" aria-expanded="false" data-target="#${divid}" aria-controls="${divid}"></a>`);
        $toggler.data('waterright', waterright);
        $toggler.text(waterright.applicationid);
        if (waterright.diversions.length != 1) {
            $(`<span class="small"> &nbsp; (${waterright.diversions.length} PODs)</span>`).appendTo($toggler);
        }
        $toggler.attr('data-waterright-id', waterright.id);
        $toggler.prop('title', "Click to show/hide details for this water right.");
        $('<i class="glyphicons glyphicons-chevron-right"></i>').appendTo($toggler);

        const $deetsdiv = $(`<div class="SearchResults-Result-Details collapse" data-parent="#SearchResults" id="${divid}"></div>`);
        $deetsdiv.data('waterright', waterright);

        $('<span>Date Accepted: </span>').append($('<span class="bold"></span>').text(waterright.acceptdate)).appendTo($deetsdiv);
        $('<br />').appendTo($deetsdiv);
        $('<span>Face Value: </span>').append($('<span class="bold"></span>').text(waterright.facevalue)).appendTo($deetsdiv);
        $('<br />').appendTo($deetsdiv);
        $('<span>Owner: </span>').append($('<span class="bold"></span>').text(waterright.owner)).appendTo($deetsdiv);
        $('<br />').appendTo($deetsdiv);
        $('<span>Riparian: </span>').append($('<span class="bold"></span>').text(waterright.riparian ? 'Yes' : 'No')).appendTo($deetsdiv);
        $('<br />').appendTo($deetsdiv);
        $('<span>Pre 1914: </span>').append($('<span class="bold"></span>').text(waterright.pre1914 ? 'Yes' : 'No')).appendTo($deetsdiv);
        $('<br />').appendTo($deetsdiv);

        waterright.diversions.forEach(function (diversion) {
            const $podsdiv = $(`<div class="SearchResults-Result-Diversion" data-diversion-id="${diversion.id}"></div>`);
            $podsdiv.data('diversion', diversion);

            // see also showDiversionInfoPopup() where a second Analyze button may exist in the Diversion's info popup
            const $analyzebutton = $('<button class="btn btn-sm btn-primary SearchResults-Result-DiversionAnalyzeButton">Analyze <i class="glyphicons glyphicons-paragraph"></i></button>');
            $analyzebutton.prop('title', "Get an analysis of water rights along this stream.");
            $analyzebutton.appendTo($podsdiv);

            $('<span>POD ID: </span>').append($('<span class="bold"></span>').text(diversion.podid)).append($('<i class="glyphicons glyphicons-search" title="Zoom the map to this POD"></i>')).appendTo($podsdiv);
            $('<br />').appendTo($podsdiv);
            $('<span>POD Types: </span>').append($('<span class="bold"></span>').text(diversion.podtypes)).appendTo($podsdiv);
            $('<br />').appendTo($podsdiv);
            $('<span>Source: </span>').append($('<span class="bold"></span>').text(diversion.source)).appendTo($podsdiv);
            $('<br />').appendTo($podsdiv);
            $('<span>Lat, Lon: </span>').append($('<span class="bold"></span>').text(`${diversion.latitude.toFixed(5)},${diversion.longitude.toFixed(5)}`)).appendTo($podsdiv);
            $('<br />').appendTo($podsdiv);

            $podsdiv.appendTo($deetsdiv);
        });

        // done
        $toggler.appendTo($readout);
        $deetsdiv.appendTo($readout);
    });
}


function performSearch_ResultCountReadout () {
    const $readout = $('#SearchResults-Count');

    if (WATERRIGHT_SEARCH_RESULTS) {
        $readout.text(WATERRIGHT_SEARCH_RESULTS.length);
        $readout.removeClass('d-none');
    }
    else {
        $readout.text('0');
        $readout.addClass('d-none');
    }
}


function redrawMapMarkers () {
    // the all-in-one way to redraw Diversion markers to whatever state; see the STYLE declarations for a summary
    // remember:
    // for search results, style matches if the Water Right matches and Application ID in the search results
    // for analysis results, only the selfsame Diversion matches
    // we may not even be doing a search at all, so all markers in the universe go onto the map with a default style

    // start by clearing all markers
    MAP.diversionmarkers.clearLayers();

    const params = compileSearchParams();
    const isrealsearch = Object.keys(params).length > 0;
    const isanalysis = DIVERSION_ANALYSIS_RESULTS;

    const searchapplicationids = listSearchResultApplicationIds();

    const analysisdiversionids = listAnalysisDiversionIds();
    const analysisdiversion = listAnalysisSelectedDiversion();

    MAP.allpodmarkers.forEach(function (layer) {
        const thisappid = layer.feature.properties.waterright_applicationid;
        const isinsearchresults = searchapplicationids.indexOf(thisappid) != -1;

        const thisdiversionid = layer.feature.properties.id;
        const isinanalysis = analysisdiversionids.indexOf(thisdiversionid) != -1;
        const istheanalyzeddiversion = analysisdiversion && thisdiversionid == analysisdiversion.id;

        // collect a list of "flags" to be applied to the layer in addition to its style
        // because iconCreateFunction() needs to refer to these layers' styles and the reasons for the styles, to determine a style for the cluster
        layer.flags = {
            istheanalyzeddiversion,
            isinanalysis,
            isinsearchresults,
        };

        if (! isrealsearch && ! isanalysis) {
            // not even doing a search: default style, all layers
            layer.setStyle(DIVERSION_POINT_DEFAULT_STYLE).addTo(MAP.diversionmarkers);
        }
        else if (istheanalyzeddiversion) {
            // this layer is for the Dversion being analyzed, gets a very prominent style
            layer.setStyle(DIVERSION_POINT_ANALYSISQUERY_STYLE).addTo(MAP.diversionmarkers).bringToBack();  // much larger icon, so send them to back so others at same latlng are visible
        }
        else if (isinanalysis) {
            // if it's an Analyze layer, pick upstream/downstream style; hydroseq decreases downstream, increases upstream
            // the two records are different structure: this layer is a Diversion layer loaded at startup; the Analyze Diversion is from Analyze API output
            const upstream = layer.feature.properties.stream_hydroseq > analysisdiversion.stream.hydroseq;
            if (upstream) {
                layer.setStyle(DIVERSION_POINT_ANALYSIS_UPSTREAM_STYLE).addTo(MAP.diversionmarkers).bringToFront();  // bring analytical results above just search results
                layer.flags.upstream = true;
            }
            else {
                layer.setStyle(DIVERSION_POINT_ANALYSIS_DOWNSTREAM_STYLE).addTo(MAP.diversionmarkers).bringToFront();  // bring analytical results above just search results
                layer.flags.downstream = true;
            }
        }
        else if (isinsearchresults) {
            layer.setStyle(DIVERSION_POINT_MATCHSEARCH_STYLE).addTo(MAP.diversionmarkers);
        }
        else {
            // layer does not go onto the map
            layer.setStyle(DIVERSION_POINT_DEFAULT_STYLE);
        }
    });

//GDA

    // refresh the clustering, since the clusers' styling depends on the styling of their contained markers e.g. all-upstream gets upstream color
    // see its iconCreateFunction() for details
    MAP.diversionmarkers.refreshClusters();
}


function selectBoundaryLayer (selectedboundary) {
    // the MAPLAYERS.filter_XXX are contrived to match to the select inputs used for filtering
    // such that toggling the input's DIV, will also toggle this layer on the map
    Object.keys(MAPLAYERS).filter(layername => layername.indexOf('filter_') == 0).forEach(function (layername) {
        const istheone = layername == `filter_${selectedboundary}`;
        const maplayer = MAPLAYERS[layername];

        if (istheone) {
            MAP.addLayer(maplayer);
        }
        else {
            MAP.removeLayer(maplayer);
        }
    });
}


function getDiversionMarkerById (diversionid) {
    // get a Diversion marker by its ID (not the POD ID) and return it
    // use case is wanting to find a specific Diversion's marker, e.g. to zoom to it or highlight it or something
    let marker;
    MAP.diversionmarkers.eachLayer(function (layer) {
        if (layer.feature.properties.id == diversionid) marker = layer;
    });
    return marker;  // may be undefined if we didn't find anything
}


function showStreamInfoPopup (latlng, gmlstreaminfo) {
    // this is a GML/XML document, which jQuery handles just fine
    // the syntax is just slightly different since our values are DOM node text
    const stream = gmlstreaminfo.find('streams_feature').first();
    if (! stream.length) return;

    const html = `
    <div class="container Stream-Popup">
        <div class="row">
            <div class="col">NHDPlus ID</div>
            <div class="col bold">${stream.find('nhdplusid').text()}</div>
        </div>
        <div class="row">
            <div class="col">Reach Code</div>
            <div class="col bold">${stream.find('reachcode').text()}</div>
        </div>
        <div class="row">
            <div class="col">Hydroseq</div>
            <div class="col bold">${stream.find('hydroseq').text() ? stream.find('hydroseq').text() : 'not connected' }</div>
        </div>
    </div>
    `;

    MAP.openPopup(html, latlng, {
        minWidth: 225,
        maxWidth: 225,
        autoPan: false,
    });
}


function showDiversionInfoPopup (marker) {
    // marker is one of the Diversion markers loaded at startup, and marker.feature.properties has the attributes
    // this may seem analogous to Diversion info in performSearch_ResultListing() but it isn't closely related aside from being Diversion points
    // the results listing are for search results, not these visible, clickable markers
    const $html = $(`
    <div class="container Diversion-Popup">
        <div class="row">
            <div class="col">POD ID</div>
            <div class="col bold">${marker.feature.properties.podid}</div>
        </div>
        <div class="row">
            <div class="col">Application Number</div>
            <div class="col bold">${marker.feature.properties.waterright_applicationid}</div>
        </div>
        <div class="row">
            <div class="col">Source</div>
            <div class="col bold">${marker.feature.properties.source}</div>
        </div>
        <div class="row">
            <div class="col">POD Types</div>
            <div class="col bold">${marker.feature.properties.types}</div>
        </div>

        <div class="row">
            <div class="col">Status</div>
            <div class="col bold">${marker.feature.properties.status}</div>
        </div>
        <div class="row">
            <div class="col">Diversion</div>
            <div class="col bold">${marker.feature.properties.diversion}</div>
        </div>
        <div class="row">
            <div class="col">Storage</div>
            <div class="col bold">${marker.feature.properties.storage}</div>
        </div>
        <div class="row">
            <div class="col">Stream NHDPlus ID</div>
            <div class="col bold">${marker.feature.properties.stream_reachcode ? marker.feature.properties.stream_reachcode : 'no stream' }</div>
        </div>
        <div class="row">
            <div class="col">Stream Hydroseq</div>
            <div class="col bold">${marker.feature.properties.stream_hydroseq ? marker.feature.properties.stream_hydroseq : 'not connected' }</div>
        </div>
        <div class="row">
            <div class="col">Lat,Lon</div>
            <div class="col bold">${marker.feature.properties.latitude.toFixed(5)},${marker.feature.properties.longitude.toFixed(5)}</div>
        </div>
    </div>
    `);

    // add the Diversion's data to the popup, so we can introspect it for buttons and actions, such as those created immediately below
    $html.data('diversion', marker.feature.properties);

    // if this marker is in our search results, and therefore in the left-hand panel, do two things
    // they didn't ask for this, but they would notice if we didn't predict this and do it as a usability enhancement
    // - in the Search Results, scroll to this Water Right result
    // - add to the popup an Analyze button (duplicating the one in the Water Right result we scrolled to)
    // see initSearchResults() for the delegated event handlers for Analyze buttons
    // see performSearch_ResultListing() which populates the listing
    const canbeanalyzed = marker.feature.properties.stream_hydroseq;
    const isinsearchresults = listSearchResultApplicationIds().indexOf(marker.feature.properties.waterright_applicationid) != -1;
    if (isinsearchresults && canbeanalyzed) {
        // add a second Analyze button to the HTML
        const $button = $('<button class="btn btn-primary btn-sm Diversion-Popup-DiversionAnalyzeButton">Analyze <i class="glyphicons glyphicons-paragraph"></i></button>');
        $('<div class="right mt-2"></div>').append($button).appendTo($html);

        // expand the result
        const waterrightid = marker.feature.properties.waterright_id;
        expandWaterRightResultById(waterrightid);
    }

    // oh right, the popup...
    // go ahead and open that
    MAP.openPopup($html.get(0), marker.getLatLng(), {
        minWidth: 300,
        maxWidth: 500,
        autoPan: false,
    });
}


function expandWaterRightResultById (waterrightid) {
    const $sidebar = $('#Sidebar');
    const $readout = $('#SearchResults');
    const $wrtitle = $readout.children(`a.SearchResults-Result-Title[data-waterright-id="${waterrightid}"]`);

    if (! $wrtitle.length) return;  // not found, oh well

    // if collapsed, click to expand
    if ($wrtitle.hasClass('collapsed')) {
        $wrtitle.click();
    }

    // scroll to it; specifically try to get it into the center of the left-hand area
    const scrollto = $sidebar.scrollTop() + $wrtitle.position().top - $wrtitle.height() - (0.5 * $(window).height());
    $sidebar.scrollTop(scrollto);
}


function listSearchResultApplicationIds () {
    return WATERRIGHT_SEARCH_RESULTS ? WATERRIGHT_SEARCH_RESULTS.map(wr => wr.applicationid) : [];
}


function listAnalysisDiversionIds () {
    return DIVERSION_ANALYSIS_RESULTS ? DIVERSION_ANALYSIS_RESULTS.streamdiversions.map(diversion => diversion.id) : [];
}


function listAnalysisSelectedDiversion () {
    return DIVERSION_ANALYSIS_RESULTS ? DIVERSION_ANALYSIS_RESULTS.query : undefined;
}


function runDiversionAnalysis (diversionid) {
    // start by closing any popup since it's surely not relevant now
    // and of course block the UI
    MAP.closePopup();
    showOneMomentPlease(true);

    const url = `/prioritytool/analyze/diversion/${diversionid}/`;
    $.get(url, {}, function (analysis) {
        showOneMomentPlease(false);

        DIVERSION_ANALYSIS_RESULTS = analysis;  // include .query for the queried Diversion, and .streamdiversions of all diversions along the stream

        showAnalysis();
        runDiversionAnalysis_updateTitleBar();
        runDiversionAnalysis_updateListing();
        runDiversionAnalysis_zoomToDiversions();
        redrawMapMarkers();
    }, 'json')
    .fail(function(xhr) {
        showOneMomentPlease(false);
        const errmsg = xhr.responseText ? xhr.responseText : "There was a problem fetching the analysis. Please report this.";
        alert(errmsg);
    });
}


function showAnalysis () {
    // see initAnalysisResults() for event handlers e.g. the Back button
    const $analysis = $('#DiversionAnalysis');
    const $searchui = $('#Sidebar-Accordion');

    $analysis.removeClass('d-none');
    $searchui.addClass('d-none');
}


function clearAnalysis () {
    // see initAnalysisResults() for event handlers e.g. the Back button
    const $analysis = $('#DiversionAnalysis');
    const $searchui = $('#Sidebar-Accordion');

    $analysis.addClass('d-none');
    $searchui.removeClass('d-none');

    // now clear the analysis results
    // and redraw a few things
    DIVERSION_ANALYSIS_RESULTS = undefined;
    redrawMapMarkers();
}


function runDiversionAnalysis_zoomToDiversions () {
    if (! DIVERSION_ANALYSIS_RESULTS) return;

    const analysisdiversionids = listAnalysisDiversionIds();

    const markers = [];
    MAP.diversionmarkers.eachLayer(function (layer) {
        const thisdiversionid = layer.feature.properties.id;
        const isinanalysis = analysisdiversionids.indexOf(thisdiversionid) != -1;

        if (isinanalysis) markers.push(layer);
    });

    const bbox = L.featureGroup(markers).getBounds().pad(0.5);
    MAP.fitBounds(bbox);
}


function runDiversionAnalysis_updateTitleBar () {
    const $analysis = $('#DiversionAnalysis');
    const $titlebar = $analysis.find('div.titlebar');

    $titlebar.find('span[data-field="podid"]').text(DIVERSION_ANALYSIS_RESULTS ? DIVERSION_ANALYSIS_RESULTS.query.podid : '');
    $titlebar.find('span[data-field="waterright.applicationid"]').text(DIVERSION_ANALYSIS_RESULTS ? DIVERSION_ANALYSIS_RESULTS.query.waterright.applicationid : '');
}


function runDiversionAnalysis_updateListing () {
    const $listing = $('#DiversionAnalysis-DiversionListing');
    const $sorter = $('#DiversionAnalysis-SortLegend select');
    const sortby = $sorter.val();

    $listing.empty();
    if (! DIVERSION_ANALYSIS_RESULTS) return;

    // sort the analysis diversions, by whatever was selected
    // well, not quite: for a date sort, Pre1914 and Riparian rights always come first (negative infinity)
    const diversions = DIVERSION_ANALYSIS_RESULTS.streamdiversions.slice();  // slice so we don't re-sort the global in-place, but still don't mutate these as that still affects the global
    diversions.sort(function (p, q) {
        switch (sortby) {
            case 'streamorder':
                return p.stream.hydroseq == q.stream.hydroseq ? 0 : (p.stream.hydroseq > q.stream.hydroseq ? -1 : 1);
            case '-streamorder':
                return p.stream.hydroseq == q.stream.hydroseq ? 0 : (p.stream.hydroseq > q.stream.hydroseq ? 1 : -1);
            case 'acceptdate':
                if (p.waterright.pre1914 && ! q.waterright.pre1914) return -1;
                if (! p.waterright.pre1914 && q.waterright.pre1914) return 1;
                if (p.waterright.riparian && ! q.waterright.riparian) return -1;
                if (! p.waterright.riparian && q.waterright.riparian) return 1;

                return p.waterright.acceptdate > q.waterright.acceptdate ? 1 : -1;
            case '-acceptdate':
                if (p.waterright.pre1914 && ! q.waterright.pre1914) return 1;
                if (! p.waterright.pre1914 && q.waterright.pre1914) return -1;
                if (p.waterright.riparian && ! q.waterright.riparian) return 1;
                if (! p.waterright.riparian && q.waterright.riparian) return -1;

                return p.waterright.acceptdate > q.waterright.acceptdate ? -1 : 1;
            case 'facevalue':
                return p.waterright.facevalue == q.waterright.facevalue ? 0 : (p.waterright.facevalue > q.waterright.facevalue ? 1 : -1);
            case '-facevalue':
                return p.waterright.facevalue == q.waterright.facevalue ? 0 : (p.waterright.facevalue > q.waterright.facevalue ? -1 : 1);
            default:
                throw new Error(`runDiversionAnalysis_updateListing() unknown sorting ${sortby}`);
        }
    });

    // draw the listing; remember that the selected Diversion gets a special style, with images to compose a border and all
    const querieddiversion = listAnalysisSelectedDiversion();
    diversions.forEach(function (diversion) {
        const istheselecteddiversion = diversion.id == querieddiversion.id;
        const upstream = diversion.stream.hydroseq > querieddiversion.stream.hydroseq;

        const $div = $('<div class="AnalysisDiversion p-2"></div>').attr('data-diversion-id', diversion.id).data('diversion', diversion);  // the Analysis object including this Diversion, its Stream, its WaterRight, ...
        if (istheselecteddiversion) {
            $div.addClass('QueriedDiversion');  // add special style + fake border areas
            $('<span class="fakeborder fakeborder-top"></span>').appendTo($div);
            $('<span class="fakeborder fakeborder-bottom"></span>').appendTo($div);
            $div.addClass('pt-4').addClass('pb-4');  // replace padding, required for the "border" images not to collide
        }

        if (! istheselecteddiversion) {
            $(`<span class="circle circle-${upstream ? 'upstream' : 'downstream'}"></span>`).appendTo($div);
        }

        if (diversion.waterright.riparian) {
            $('<img src="/static/images/icon-riparian.png" />').appendTo($div);
        }
        if (diversion.waterright.pre1914) {
            $('<img src="/static/images/icon-pre1914.png" />').appendTo($div);
        }

        $(`<div>
            POD ID: <a href="javascript:void(0);" class="AnalysisDiversion-DiversionIdButton" title="Focus the map to this point of diversion"><span class="bold">${diversion.podid}</span></a>
            <br/>
            Water Right: <span class="bold">${diversion.waterright.applicationid}</span>
            <br/>
            Accept Date: <span class="bold">${diversion.waterright.acceptdate}</span>
            <br/>
            Owner: <span class="bold">${diversion.waterright.owner}</span>
            <br/>
            Face Value: <span class="bold">${diversion.waterright.facevalue.toLocaleString()}</span>
        </div>`).appendTo($div);

        $div.appendTo($listing);
    });

    // postprocessing hack for the Diversion that we are analyzing
    // tweak the border on the .AnalysisDiversion before & after the selected one, so we don't have double-border
    // also
    // scroll down to the selected Diversion's block
    const $selecteddiv = $listing.find('.QueriedDiversion');
    $selecteddiv.next('.AnalysisDiversion').addClass('AfterQueriedDiversion');
    $selecteddiv.prev('.AnalysisDiversion').addClass('BeforeQueriedDiversion');

    const $sidebar = $('#Sidebar');
    const scrollto = $sidebar.scrollTop() + $selecteddiv.position().top - $selecteddiv.height() - (0.5 * $(window).height());
    $sidebar.scrollTop(scrollto);

}
